export class GatewayType {
  id!: number;
  modelName!: string;
  partNumber?: string;
  osType!: string;
  additionalInfo?: GatewayTypeAdditionalInfo;

  constructor() {
    this.additionalInfo = new GatewayTypeAdditionalInfo();
  }

}

class GatewayTypeAdditionalInfo {
  rtuPorts?: string[];

  constructor() {
    this.rtuPorts = [];
  }

}
